import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { stringify } from 'qs';

interface IProFormasQueryParams {
    dealId: number;
    proFormaStatusIds?: number[];
}

interface IBOEScenario {
    id: number;
    name: string;
}

export interface IProForma {
    id: number;
    name: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    updatedBy: string;
    boeScenarioId: number | null;
    boeScenario: IBOEScenario | null;
    proFormaModelId: number | null;
    proFormaModelName: string | null;
    proFormaStatusId: number;
    draftStep: number;
    subprojectId: string | null;
    projectBudgetScenarioId: string | null;
}

const getProFormas = async ({ dealId, proFormaStatusIds }: IProFormasQueryParams): Promise<IProForma[]> => {
    const params: any = {};
    if (proFormaStatusIds && proFormaStatusIds.length > 0) {
        params.proFormaStatusIds = proFormaStatusIds;
    }
    const response = await axiosInstance.get(
        `${API_ENDPOINTS.PRO_FORMA(dealId)}`,
        {
            params,
            paramsSerializer: params => stringify(params, { arrayFormat: 'repeat' }),
        },
    );
    return response.data;
};

export const useGetProFormasByDeal = ({ dealId, proFormaStatusIds }: IProFormasQueryParams,
    options: Omit<UseQueryOptions<IProForma[], Error, IProForma[]>, 'queryKey' | 'queryFn'> = {
        staleTime: 5000,
        refetchOnMount: true,
    }) => useQuery({
    queryKey: ['getProFormas', dealId, proFormaStatusIds],
    queryFn: () => getProFormas({ dealId, proFormaStatusIds }),
    ...options,
});
